module.exports = __webpack_public_path__ + "img/delivery-bed.61e2a553.jpg";